import React from "react";
import { motion, AnimatePresence } from "framer-motion";

// Inject CSS directly into the component (self-contained)
const tooltipStyles = `
.gradient-tooltip {
  --s: 12px;
  --r: 10px;

  color: white;
  background: border-box linear-gradient(60deg, #2563eb, #4fc3f7);
  padding: 10px 14px;
  font-size: 13px;
  border: var(--s) solid transparent;
  max-width: 240px;
  text-align: left;

  border-radius: calc(var(--r) + var(--s));
  border-bottom-left-radius: 0;

  -webkit-mask:
    radial-gradient(100% 100% at 100% 100%, transparent 98%, black 102%)
      var(--s) 100%/var(--s) var(--s) no-repeat border-box,
    linear-gradient(#000 0 0) padding-box;

  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
`;

if (typeof document !== "undefined" && !document.getElementById("tooltip-bubble-style")) {
    const styleTag = document.createElement("style");
    styleTag.id = "tooltip-bubble-style";
    styleTag.innerHTML = tooltipStyles;
    document.head.appendChild(styleTag);
}

const TooltipBubble = ({
    show,
    message,
    className = "",
    slideDistance = 80,
    animationDuration = 0.5,
    fadeDelay = 0.15,
    delayBeforeShow = 0
}) => {
    const [shouldShow, setShouldShow] = React.useState(false);

    React.useEffect(() => {
        if (show && delayBeforeShow > 0) {
            const timer = setTimeout(() => {
                setShouldShow(true);
            }, delayBeforeShow);
            return () => clearTimeout(timer);
        } else if (show) {
            setShouldShow(true);
        } else {
            setShouldShow(false);
        }
    }, [show, delayBeforeShow]);

    return (
        <AnimatePresence>
            {shouldShow && (
                <motion.div
                    initial={{
                        opacity: 0,
                        x: -slideDistance,
                    }}
                    animate={{
                        opacity: 1,
                        x: 0,
                        transition: {
                            duration: animationDuration,
                            ease: [0.25, 0.1, 0.25, 1],
                            opacity: { duration: animationDuration * 0.8 },
                        },
                    }}
                    exit={{
                        opacity: 0,
                        x: slideDistance,
                        transition: {
                            duration: animationDuration * 0.8,
                            ease: [0.25, 0.1, 0.25, 1]
                        },
                    }}
                    className={`gradient-tooltip absolute ${className}`}
                    style={{
                        pointerEvents: "none",
                        width: "229px",
                        height: "59px",
                        fontSize: "10px",
                        padding: "4px",
                        zIndex: 1,
                        willChange: "transform, opacity",
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{
                            opacity: 1,
                            transition: { delay: fadeDelay, duration: animationDuration * 0.6 }
                        }}
                    >
                        {message}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default TooltipBubble;